import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import AutoCarousel from "./AutoCarousel";

export default function EmployerCarousel() {
  const [employers, setEmployers] = useState([]);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const url = (typeof constvar !== "undefined" ? constvar.api_url : "/api/") + "home/get_employer_carousel";

    axios
      .get(url, {
        signal: controller.signal,
      })
      .then((res) => {
        if (!isMounted) return;
        if (res.data.status === "success") {
          setEmployers(res.data.data || []);
        }
      })
      .catch((error) => {
        if (!isMounted) return;
        if (error.name !== "AbortError" && error.name !== "CanceledError") {
          console.error("Failed to load employer carousel:", error);
        }
      });

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  const carouselItems =
    employers.length > 0
      ? employers
      : Array.from({ length: 8 }, (_, i) => ({
          id: i,
          comp_name: "Company",
          imgUrl: "/default/default_company_logo.jpg",
          clientslug: "#",
        }));

  return (
    <section id="trusted-partner" className="sf-light-gray trusted_partner">
      <div className="sf-container">
        <AutoCarousel title="Trusted By Leading Companies">
          {carouselItems.map((emp) => (
            <Link
              key={emp.id}
              to={emp.clientslug !== "#" ? `/company/${emp.clientslug}` : "/"}
              className="sf-employer-logo"
            >
              <img src={emp.imgUrl} alt={emp.comp_name} />
            </Link>
          ))}
        </AutoCarousel>
      </div>
    </section>
  );
}
